export default {
  toggleDrawer(state) {
    state.drawerVisible = !state.drawerVisible;
  },
  setSnackbarProps(state, {
    text = '', color = '', timeout = 3500, show = true,
  }) {
    state.snackbar.text = text;
    state.snackbar.color = color;
    state.snackbar.timeout = timeout;
    state.snackbar.show = show;
  },
  hideOverlay(state){
    state.overlay = false;
  },
  showOverlay(state){
    state.overlay = true;
  },
};
